$(function () {
  $(".pdp_readmore").click(function (e) {
    e.preventDefault();
    var parent_el = $(this).closest(".product-single__cta");
    parent_el.find(".product-description-full").show();
    parent_el.find(".product-description-short").hide();
  });
});

function selectVariantById(variantId) {
  const selectElement = document.querySelector('select[name="id"]');

  for (let i = 0; i < selectElement.options.length; i++) {
    if (selectElement.options[i].value == variantId) {
      selectElement.options[i].selected = true;
      selectElement.options[i].setAttribute("selected", "selected");
      selectElement.selectedIndex = i;
    } else {
      selectElement.options[i].selected = false;
      selectElement.options[i].removeAttribute("selected");
    }
  }

  const event = new Event("change");

  setTimeout(() => {
    selectElement.dispatchEvent(event);
  }, 100);
}

function updateProductPrice(variant) {
  const comparePrice = variant.compare_at_price;
  const finalPrice = variant.price;

  const regularPriceElement = document.querySelector(".price-item--regular");
  const salePriceElement = document.querySelector(".price-item--sale");

  if (
    regularPriceElement &&
    comparePrice &&
    comparePrice > finalPrice &&
    salePriceElement
  ) {
    const formattedComparePrice = comparePrice / 100;
    const formattedPrice = finalPrice / 100;
    regularPriceElement.textContent = `$${formattedComparePrice}`;
    salePriceElement.textContent = `$${formattedPrice}`;
  } else if (!comparePrice) {
    const formattedPrice = finalPrice / 100;
    regularPriceElement.textContent = `$${formattedPrice}`;
  }
}

function evaluateSelectedVariant() {
  const variantBox = document.querySelector(".variant-box-selector");
  const runVariantBox = variantBox.dataset.crossVariants;
  if (runVariantBox == "false") {
    const selectedVariant = {};
    variantBox.querySelectorAll("ul").forEach((ul, index) => {
      const selectedLi = ul.querySelector("li.selected");
      if (selectedLi) {
        selectedVariant[`option${index + 1}`] = selectedLi.dataset.value;
      }
    });
    let selectedVariantObj = {};

    product.variants.forEach((variant) => {
      if (variant.option1) {
        if (variant.option1 == selectedVariant.option1) {
          if (variant.option2) {
            if (variant.option2 == selectedVariant.option2) {
              if (variant.option3) {
                if (variant.option3 == selectedVariant.option3) {
                  selectedVariantObj.id = variant.id;
                  selectedVariantObj.available = variant.available;
                }
              } else {
                selectedVariantObj.id = variant.id;
                selectedVariantObj.available = variant.available;
              }
            }
          } else {
            selectedVariantObj.id = variant.id;
            selectedVariantObj.available = variant.available;
          }
        }
      }
    });

    updateProductPrice(
      product.variants.find((v) => v.id == selectedVariantObj.id)
    );

    variantBox.querySelectorAll("ul").forEach((ul, _index) => {
      ul.querySelectorAll("li").forEach((li) => {
        li.classList.remove("unavailable");
      });
      const selectedLi = ul.querySelector("li.selected");
      document.querySelector("#AddToCart-product-template").style.display =
        "flex";
      const kvBtn = document.querySelector(
        ".btn.product-form__cart-submit.klaviyo-bis-trigger"
      );
      if (kvBtn) {
        kvBtn.style.display = "none";
      }

      if (selectedLi && !selectedVariantObj.available) {
        selectedLi.classList.add("unavailable");
        document.querySelector("#AddToCart-product-template").style.display =
          "none";
        const kvBtn = document.querySelector(
          ".btn.product-form__cart-submit.klaviyo-bis-trigger"
        );

        if (kvBtn) {
          kvBtn.style.display = "block";
        }

        calculateOutOfStockAngle();
      }
    });

    selectVariantById(selectedVariantObj.id);

    return selectedVariantObj;
  }
}

function initVariantSelector() {
  const variantBox = document.querySelector(".variant-box-selector");
  const runVariantBox = variantBox.dataset.crossVariants;
  if (runVariantBox == "false") {
    variantBox.querySelectorAll("ul").forEach((ul) => {
      let currentIndex = -1;

      ul.querySelectorAll("li").forEach((li) => {
        li.addEventListener("click", () => {
          ul.querySelectorAll("li").forEach((li) => {
            li.classList.remove("selected");
          });
          li.classList.add("selected");
          evaluateSelectedVariant();
        });

        li.addEventListener("keydown", (event) => {
          const key = event.key;
          const liItems = ul.querySelectorAll("li");

          if (key === "ArrowRight" || key === "ArrowLeft") {
            event.preventDefault();

            if (key === "ArrowRight") {
              currentIndex = (currentIndex + 1) % liItems.length; // Move to the next item
            } else if (key === "ArrowLeft") {
              currentIndex =
                (currentIndex - 1 + liItems.length) % liItems.length; // Move to the previous item
            }

            liItems[currentIndex]?.focus();
          }

          if (key === "Enter" || key === " ") {
            if (!liItems[currentIndex]) {
              liItems[currentIndex] = li;
            }
            if (!liItems[currentIndex]?.classList.contains("unavailable")) {
              liItems.forEach((li) => {
                li.classList.remove("selected");
              });
              liItems[currentIndex]?.classList.add("selected");
              evaluateSelectedVariant();
            }
          }
        });

        li.setAttribute("tabindex", 0);
      });
    });
  }
}

function forceFocus() {
  const cartIcon = document.querySelector(
    ".site-header__icon.site-header__cart"
  );
  const breadcrumbs = document.querySelector(".breadcrumbs__link");

  const mainContent = document.querySelector(".main-content");

  const focusableElements = mainContent.querySelectorAll(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
  );

  cartIcon.addEventListener("keydown", function (event) {
    if (event.key === "Tab" && !event.shiftKey) {
      event.preventDefault();
      if (focusableElements.length > 0) {
        focusableElements[0].focus();
      } else if (window.location.href.includes("/products/")) {
        breadcrumbs.focus();
      }
    }
  });
}

function calculateOutOfStockAngle() {
  const OOSElements = document.querySelectorAll(
    ".variant-box-selector li.unavailable"
  );
  if (OOSElements.length === 0) return;
  OOSElements.forEach((box) => {
    const width = box.offsetWidth;
    const height = box.offsetHeight;
    const angle = Math.atan(height / width) * (180 / Math.PI);
    box.style.setProperty("--diagonal-angle", `${angle}deg`);
  });
}

window.onload = function () {
  forceFocus();
  initVariantSelector();
  calculateOutOfStockAngle();
};

const videoElement = document.querySelector(".product-single__image video");

document.addEventListener("fullscreenchange", handleFullscreenChange);
document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

function handleFullscreenChange() {
  if (document.fullscreenElement || document.webkitFullscreenElement) {
    console.log("Video is expanded to fullscreen");
  } else {
    setTimeout(() => {
      document.querySelector(
        ".product-kit__images-nav .slick-track"
      ).style.transform = "translate3d(0, 0px, 0px)";
    }, 100);
  }
}
